import { EncounterSummaryControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useEncounterArchive = () =>
  useMutationWithLoading(
    async (params: {
      encounterSummaryId: string;
      status: boolean;
      xTENANTID?: string;
    }) =>
      new EncounterSummaryControllerApi(
        getConfigObject()
      ).updateEncounterSummaryArchiveStatus(
        params?.encounterSummaryId,
        params?.status,
        params?.xTENANTID
      )
  );
